import slug from 'slugg';

import config from 'config';
import { File } from 'types/models/File';

const { filesHostUrl = '' } = config;

type Props = {
  name: string;
  file: Pick<File, 'id' | 'basename' | 'extension'>;
};

const resolveDocumentData = ({ name, file }: Props): { fileName: string; url: string } => {
  const fileName = `${slug(name.replace(`.${file.extension}`, ''))}.${file.extension}`;
  const url = `${filesHostUrl}docs/${file.basename}/${fileName}`;

  return { fileName, url };
};

export default resolveDocumentData;
